{
  "title": "Partager votre localisation vous permet d'accélérer le processus d'enregistrement",
  "body": "Nous sommes désolés, mais nous ne pouvons pas finaliser votre enregistrement sans accès à votre localisation. Veuillez autoriser l'accès à la localisation pour continuer. Nous utilisons uniquement votre localisation à des fins d'enregistrement en entrepôt et ne stockons ni ne partageons vos informations de localisation avec des tiers.",
  "shareLocation": "Partager ma localisation"
}
